import React, { createContext, useContext, useState } from "react";
import { StandardizedOnboardingData } from "./utils/onboardingDataTransformer";
import { GfStoreDto } from "@swagger/typescript-fetch-goflyer";
import { GooglePlaceResult } from "./useStoreSearch";

export interface OnBoardingStoreSelection {
  source: "api" | "google";
  store: GfStoreDto | GooglePlaceResult;
}

interface OnBoardingContextProps {
  selectedStore: OnBoardingStoreSelection | null;
  setSelectedStore: (store: OnBoardingStoreSelection | null) => void;

  onboardingData: StandardizedOnboardingData | null;
  setOnboardingData: (data: StandardizedOnboardingData | null) => void;
}

const OnBoardingContext = createContext<OnBoardingContextProps | undefined>(
  undefined
);

export const useOnBoardingContext = () => {
  const ctx = useContext(OnBoardingContext);
  if (!ctx)
    throw new Error(
      "useOnBoardingContext must be used within OnBoardingProvider"
    );
  return ctx;
};

export const OnBoardingProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [selectedStore, setSelectedStore] =
    useState<OnBoardingStoreSelection | null>(null);

  const [onboardingData, setOnboardingData] =
    useState<StandardizedOnboardingData | null>(null);

  return (
    <OnBoardingContext.Provider
      value={{
        selectedStore,
        setSelectedStore,
        onboardingData,
        setOnboardingData,
      }}
    >
      {children}
    </OnBoardingContext.Provider>
  );
};
